/**
 * @generated SignedSource<<c3fca11dd785d3b079ad0bf8888f66a7>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ExitSlipExitSlipsBySkillsQuery$variables = {
  studentId: string;
  targetGroupId: string;
};
export type ExitSlipExitSlipsBySkillsQuery$data = {
  readonly studentExitSlipReport: ReadonlyArray<{
    readonly curriculumLessons: ReadonlyArray<{
      readonly classExitSlips: ReadonlyArray<{
        readonly classExitSlipId: number;
        readonly learnosityExitSlipSession: {
          readonly maxScore: number;
          readonly score: number;
          readonly sessionId: number;
        } | null | undefined;
      }>;
      readonly curriculumLessonId: number;
      readonly hasExitSlip: boolean;
      readonly name: string;
      readonly number: string;
    }>;
    readonly skillInfo: {
      readonly code: string;
      readonly name: string;
      readonly skillId: number;
    };
  }>;
};
export type ExitSlipExitSlipsBySkillsQuery = {
  response: ExitSlipExitSlipsBySkillsQuery$data;
  variables: ExitSlipExitSlipsBySkillsQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "studentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "targetGroupId"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "studentId",
        "variableName": "studentId"
      },
      {
        "kind": "Variable",
        "name": "targetGroupId",
        "variableName": "targetGroupId"
      }
    ],
    "concreteType": "StudentExitSlipReport",
    "kind": "LinkedField",
    "name": "studentExitSlipReport",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "CurriculumLessonInfo",
        "kind": "LinkedField",
        "name": "curriculumLessons",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "hasExitSlip",
            "storageKey": null
          },
          {
            "alias": "curriculumLessonId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v1/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "number",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassExitSlipInfo",
            "kind": "LinkedField",
            "name": "classExitSlips",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "LearnosityExitSlipSessionInfo",
                "kind": "LinkedField",
                "name": "learnosityExitSlipSession",
                "plural": false,
                "selections": [
                  {
                    "alias": "sessionId",
                    "args": null,
                    "kind": "ScalarField",
                    "name": "id",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "maxScore",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "score",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": "classExitSlipId",
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "BaseSkillInfo",
        "kind": "LinkedField",
        "name": "skillInfo",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "code",
            "storageKey": null
          },
          {
            "alias": "skillId",
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          (v1/*: any*/)
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ExitSlipExitSlipsBySkillsQuery",
    "selections": (v2/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ExitSlipExitSlipsBySkillsQuery",
    "selections": (v2/*: any*/)
  },
  "params": {
    "cacheID": "15cb27e1816b27a1313f7b76c770975b",
    "id": null,
    "metadata": {},
    "name": "ExitSlipExitSlipsBySkillsQuery",
    "operationKind": "query",
    "text": "query ExitSlipExitSlipsBySkillsQuery(\n  $studentId: ID!\n  $targetGroupId: ID!\n) {\n  studentExitSlipReport(studentId: $studentId, targetGroupId: $targetGroupId) {\n    curriculumLessons {\n      hasExitSlip\n      curriculumLessonId: id\n      name\n      number\n      classExitSlips {\n        learnosityExitSlipSession {\n          sessionId: id\n          maxScore\n          score\n        }\n        classExitSlipId: id\n      }\n    }\n    skillInfo {\n      code\n      skillId: id\n      name\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e4905979bd66ef45b55ce8a0557b04a7";

export default node;
